// extracted by mini-css-extract-plugin
module.exports = {"button":"PrevButton_button__RO8SA","active":"PrevButton_active__TZN7y"};